import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, Fragment as _Fragment, renderList as _renderList, renderSlot as _renderSlot, vShow as _vShow, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-f1aaabc2")

_pushScopeId("data-v-f1aaabc2")
const _hoisted_1 = {
  key: 0,
  class: "multiple-select-item margin-left5px"
}
const _hoisted_2 = {
  key: 0,
  class: "multiple-select-item margin-left5px"
}
const _hoisted_3 = /*#__PURE__*/_createVNode("i", {
  class: "el-icon-my-multiple-select-close",
  style: {"cursor":"not-allowed"}
}, null, -1)
const _hoisted_4 = {
  key: 1,
  style: {"color":"#C0C4CC"}
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", {
    ref: "select",
    tabindex: 0,
    class: ["select-result-container", _ctx.disabled === false ? '' : 'disalble-select'],
    style: {width: _ctx.width, height: _ctx.multiple ? 'auto' : ''},
    onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.clickHandler && _ctx.clickHandler(...args))),
    onBlur: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.inputBlur && _ctx.inputBlur(...args)))
  }, [
    (_ctx.disabled === false)
      ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
          (!_ctx.multiple)
            ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                (_ctx.isShowFilterInput === false)
                  ? (_openBlock(), _createBlock("div", {
                      key: 0,
                      title: _ctx.selectedValue.match ? _ctx.selectedValue.label : _ctx.placeholder,
                      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.setFilter && _ctx.setFilter(...args))),
                      class: "select-result-label",
                      style: { color: _ctx.selectedValue.match ? '' : (_ctx.modelValue? '' : '#b2b2b2') }
                    }, _toDisplayString(_ctx.selectedValue.match ? _ctx.selectedValue.label :
                        (_ctx.modelValue?_ctx.modelValue: _ctx.placeholder)), 13, ["title"]))
                  : _withDirectives((_openBlock(), _createBlock("input", {
                      key: 1,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectedValue.filterValue = $event)),
                      ref: "filterInput",
                      class: "select-result-label result-input",
                      onBlur: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.inputBlur && _ctx.inputBlur(...args))),
                      placeholder: _ctx.placeholder
                    }, null, 40, ["placeholder"])), [
                      [_vModelText, _ctx.selectedValue.filterValue]
                    ])
              ], 64))
            : (_openBlock(), _createBlock("div", {
                key: 1,
                class: "flex1",
                style: {"cursor":"auto"},
                onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.setFilter && _ctx.setFilter(...args)))
              }, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.multipleSelectedValue, (multipleItem) => {
                  return (_openBlock(), _createBlock("span", {
                    key: multipleItem.selectValue.toString()
                  }, [
                    (multipleItem.choose)
                      ? (_openBlock(), _createBlock("span", _hoisted_1, [
                          _createVNode("span", null, _toDisplayString(multipleItem.label), 1),
                          _createVNode("i", {
                            class: "el-icon-my-multiple-select-close",
                            onMouseover: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.changeStateToHoverClose && _ctx.changeStateToHoverClose(...args))),
                            onMouseout: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.changeStateToNormalClose && _ctx.changeStateToNormalClose(...args))),
                            onClick: ($event: any) => (_ctx.cancelSelectedValue(multipleItem.selectValue))
                          }, null, 40, ["onClick"])
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                }), 128)),
                (_ctx.isShowFilterInput&&(_ctx.multipleSelectedValue&&_ctx.multipleSelectedValue.length==0))
                  ? _withDirectives((_openBlock(), _createBlock("input", {
                      key: 0,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.multipleFilter = $event)),
                      ref: "filterInput",
                      class: "select-result-label result-input",
                      style: {"width":"100%"},
                      onBlur: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.inputBlur && _ctx.inputBlur(...args))),
                      placeholder: _ctx.placeholder
                    }, null, 40, ["placeholder"])), [
                      [_vModelText, _ctx.multipleFilter]
                    ])
                  : _createCommentVNode("", true)
              ]))
        ], 64))
      : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
          (_ctx.multiple)
            ? (_openBlock(), _createBlock("div", {
                key: 0,
                class: "select-result-label",
                style: { color: _ctx.modelValue ? '' : '#b2b2b2' }
              }, [
                (_ctx.multipleSelectedValue&&_ctx.multipleSelectedValue.length>0)
                  ? (_openBlock(true), _createBlock(_Fragment, { key: 0 }, _renderList(_ctx.multipleSelectedValue, (multipleItem) => {
                      return (_openBlock(), _createBlock("span", {
                        key: multipleItem.selectValue.toString()
                      }, [
                        (multipleItem.choose)
                          ? (_openBlock(), _createBlock("span", _hoisted_2, [
                              _createVNode("span", null, _toDisplayString(multipleItem.label), 1),
                              _hoisted_3
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  : (_openBlock(), _createBlock("span", _hoisted_4, _toDisplayString(_ctx.placeholder), 1))
              ], 4))
            : (_openBlock(), _createBlock("div", {
                key: 1,
                style: { color: _ctx.modelValue ? '' : '#b2b2b2' },
                class: "select-result-label"
              }, _toDisplayString(_ctx.selectedValue.match ?
                    (!_ctx.selectedValue.label && ! _ctx.modelValue ? _ctx.placeholder : _ctx.selectedValue.label) :
                    (!_ctx.modelValueIsEmpty(_ctx.modelValue) ? _ctx.modelValue : _ctx.placeholder)), 5))
        ], 64)),
    _createVNode("div", {
      class: "select-result-icon display-flex justify-content-center align-items-center min-height30px",
      onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.setFilter && _ctx.setFilter(...args)))
    }, [
      _createVNode("span", {
        class: _ctx.isExpand ? 'el-icon-caret-top' : 'el-icon-caret-bottom'
      }, null, 2)
    ]),
    _withDirectives(_createVNode("ul", {
      class: "select-options",
      ref: "options",
      onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.clickOptions && _ctx.clickOptions(...args)))
    }, [
      _renderSlot(_ctx.$slots, "default")
    ], 512), [
      [_vShow, _ctx.isExpand]
    ])
  ], 38))
})